import { ArcanasTable } from '@/app/components/ArcanasTable/ArcanasTable'
import { CalcBanner } from '@/app/components/CalcBanner/CalcBanner'
import { Row } from '@/app/components/Flex/Flex'
import { Layout } from '@/app/components/Layout/Layout'
import { MenuFooter } from '@/app/components/MenuFooter/MenuFooter'
import { Motion } from '@/app/components/Motion/Motion'
import { ScrollToTop } from '@/app/components/ScrollToTop/ScrollToTop'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { useBack } from '@/app/hooks/useBack'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

type MatrixArcanaListPageType = 'Base' | 'Money'

type MatrixArcanaListPageContent = {
  title: string
  description: string
  listPath: string
  bannerTitle: string
  bannerDesc: string
  bannerBtn: string
}

const CONTENT: Record<MatrixArcanaListPageType, MatrixArcanaListPageContent> = {
  Base: {
    title: 'Арканы Матрицы судьбы',
    description:
      'Каждый аркан показывает отдельный жизненный сценарий: характер, сильные стороны, задачи, отношения и способы выйти в плюс.',
    listPath: '~/guide/matrix-arcana',
    bannerTitle: 'Твоя Матрица судьбы',
    bannerDesc: 'Арканы раскрываются точнее, когда видны их позиции и связи. Рассчитай полную Матрицу, чтобы увидеть всю картину целиком.',
    bannerBtn: 'Открыть Матрицу',
  },
  Money: {
    title: 'Денежный код',
    description:
      'Показывает основной сценарий заработка, роста дохода и финансовой реализации в Матрице судьбы. Ниже — разборы всех 22 арканов.',
    listPath: '~/guide/matrix-money',
    bannerTitle: 'Твоя Матрица судьбы',
    bannerDesc: 'Денежный код — только одна точка. Открой полную Матрицу, чтобы увидеть все арканы и связи между ними.',
    bannerBtn: 'Открыть Матрицу',
  },
}

export const MatrixArcanaListPage: FunctionalComponent<{
  type: MatrixArcanaListPageType
}> = props => {
  const back = useBack('~/tools')
  const content = CONTENT[props.type]

  return (
    <Layout>
      <ScrollToTop />

      <Layout.Content
        onBack={back}
      >
        <Motion class={styles.root}>
          <Layout.Header type='secondary'>
            Матрица судьбы
          </Layout.Header>

          <Row gap={15}>
            <UI.Panel shadow type='user'>
              <Row gap={5}>
                <Text
                  as='h1'
                  fontSize={20}
                  fontWeight={600}
                  textAlign='center'
                >
                  {content.title}
                </Text>

                <Text
                  fontSize={16}
                  textAlign='center'
                >
                  {content.description}
                </Text>
              </Row>
            </UI.Panel>

            <ArcanasTable
              getLink={page => `${content.listPath}/${page}`}
            />

            <CalcBanner
              title={content.bannerTitle}
              desc={content.bannerDesc}
              btn={content.bannerBtn}
              link='~/tools/matrix'
            />
          </Row>
        </Motion>

        <MenuFooter />
      </Layout.Content>
    </Layout>
  )
}
